import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, forEach, sum, map } from "lodash";
import FileSaver from "file-saver";
import Grid from "@material-ui/core/Grid";

import DownloadIcon from "../../Common/DownloadIcon";

const CompanyCountsCsv = (props) => {
  const { data } = props;

  const exportCsv = () => {
    const separator = ",";
    const title = I18n.get("sidebar_onsiteCounts");
    let csv = "\uFEFF";
    csv += `"${title}"\r\n`;
    csv += `${I18n.get("profiles_sites")}${separator}${I18n.get(
      "companies_zones"
    )}${separator}`;
    forEach(get(data, ["profile_types"]), (t) => {
      csv += `${get(t, ["profile_type_name"])}s${separator}`;
    });
    csv += I18n.get("dashboard_total");
    csv += "\r\n";
    forEach(get(data, ["sites"]), (site) => {
      forEach(get(site, ["zones"]), (zone) => {
        csv += `${get(site, ["site_name"])}${separator}${get(zone, [
          "zone_name",
        ])}${separator}`;
        forEach(get(zone, ["profile_types"]), (t) => {
          csv += `${get(t, ["profile_count"]) || "0"}${separator}`;
        });
        csv += sum(
          map(get(zone, ["profile_types"]), (type) =>
            get(type, ["profile_count"])
          )
        );
        csv += "\r\n";
      });
      csv += "\r\n";
    });

    const csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    FileSaver.saveAs(csvData, `${title}.csv`);
  };

  return (
    <Grid item>
      <DownloadIcon exportCsv={exportCsv} />
    </Grid>
  );
};

export default CompanyCountsCsv;
